module.exports = __webpack_public_path__ + "img/IMG_20211229_151653006_HDR.9cd7cc47.jpg";